export default [
  //通知相关
  {
  	path: '/fabutongzhi',
  	name: 'fabutongzhi2',
  	component: () => import('@/components/message/fabutongzhi')
  },
  {
  	path: '/tongzhizhongxin',
  	name: 'tongzhizhongxin',
  	component: () => import('@/components/message/tongzhizhongxin')
  },
  {
  	path: '/xitongtongzhi',
  	name: 'xitongtongzhi2',
  	component: () => import('@/components/message/xitongtongzhi')
  },
  {
  	path: '/fabuxitongtongzhi',
  	name: 'fabuxitongtongzhi',
  	component: () => import('@/components/message/fabuxitongtongzhi')
  },
  {
  	path: '/fabuxitonggonggao',
  	name: 'fabuxitonggonggao',
  	component: () => import('@/components/message/fabuxitonggonggao')
  },

  {
  	path: '/xiaoxi',
  	name: 'xiaoxik',
  	component: () => import('@/views/xiaoxi/index'),
    redirect:"/xiaoxi/xiaoxi",
    children:[
      {
      	path: '/xiaoxi/xiaoxi',
      	name: 'xiaoxi',
      	component: () => import('@/views/xiaoxi/xiaoxi')
      },
      {
      	path: '/xiaoxi/shangxiajiatongzhi',
      	name: 'shangxiajiatongzhi',
      	component: () => import('@/views/xiaoxi/shangxiajiatongzhi')
      },
      {
      	path: '/xiaoxi/xitongtongzhi',
      	name: 'xitongtongzhi',
      	component: () => import('@/views/xiaoxi/xitongtongzhi')
      },
      {
      	path: '/xiaoxi/fabutongzhi',
      	name: 'fabutongzhi',
      	component: () => import('@/views/xiaoxi/fabutongzhi')
      },
    ]
  },
  //消息通知
    {
    	path: '/xiaoxitongzhi',
    	name: 'xiaoxitongzhi',
    	component: () => import('@/views/xiaoxitongzhi/index'),
    //   component: {render: (e) => e("router-view")},
      redirect:"/xiaoxitongzhi/dingdanbiangeng",
      children:[
        {
        	path: '/xiaoxitongzhi/dingdanbiangeng',
        	name: 'dingdanbiangeng',
        	component: () => import('@/views/xiaoxitongzhi/dingdanbiangeng')
        },
        {
        	path: '/xiaoxitongzhi/yichangchuli',
        	name: 'yichangchuli',
        	component: () => import('@/views/xiaoxitongzhi/yichangchuli')
        },
        {
        	path: '/xiaoxitongzhi/yujing',
        	name: 'yujing',
        	component: () => import('@/views/xiaoxitongzhi/yujing')
        },
      ]
    },
  //投诉工单
    {
    	path: '/tousugongdan',
    	name: 'tousugongdanall',
    	component: () => import('@/views/tousugongdan/index'),
    //   component: {render: (e) => e("router-view")},
      redirect:"/tousugongdan/wode",
      children:[
        // {
        // 	path: '/tousugongdan',
        // 	name: 'tousugongdan',
        // 	component: () => import('@/views/tousugongdan')
        // },
        {
        	path: '/tousugongdan/wode',
        	name: 'tousugongdan/wode',
        	component: () => import('@/views/tousugongdan/wode')
        },
        {
        	path: '/tousugongdan/fenxiaoshang',
        	name: 'tousugongdan/fenxiaoshang',
        	component: () => import('@/views/tousugongdan/fenxiaoshang')
        },
		{
        	path: '/tousugongdan/shouhou',
        	name: 'tousugongdan/shouhou',
        	component: () => import('@/views/tousugongdan/shouhou')
        },
        {
        	path: '/tousugongdan/checkts',
        	name: 'checkts',
        	component: () => import('@/views/checkts')
        },
        {
        	path: '/tousugongdan/weixinjiqiren',
        	name: 'weixinjiqiren',
        	component: () => import('@/views/tousugongdan/weixinjiqiren')
        },
        {
        	path: '/tousugongdan/checkts2',
        	name: 'checkts2',
        	component: () => import('@/views/tousugongdan/checkts2')
        },

      ]
    },
]



// WEBPACK FOOTER //
// ./src/router/tongzhixiaoxi.js